import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle2, AlertCircle, Lock } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function RecoverPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-1525">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1526">
        {!isSubmitted ? <>
            {/* Page Header */}
            <div className="text-center mb-8" data-id="element-1527">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-purple-100 rounded-full mb-4" data-id="element-1528">
                <Lock className="w-8 h-8 text-brand-purple-600" data-id="element-1529" />
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-1530">
                Forgot Your Password?
              </h1>
              <p className="text-lg text-gray-600" data-id="element-1531">
                No problem! Enter your email address and we'll send you a link
                to reset your password.
              </p>
            </div>

            {/* Help Tips */}
            <Card className="p-6 mb-8 bg-blue-50 border-blue-200" data-id="element-1532">
              <h3 className="font-semibold text-blue-900 mb-3 flex items-center" data-id="element-1533">
                <AlertCircle className="w-5 h-5 mr-2" data-id="element-1534" />
                Password Not Working? Here Are a Few Suggestions:
              </h3>
              <ul className="space-y-2 text-sm text-blue-800" data-id="element-1535">
                <li className="flex items-start" data-id="element-1536">
                  <span className="font-semibold mr-2" data-id="element-1537">1.</span>
                  <span data-id="element-1538">
                    Look at your original registration email titled "Welcome to
                    Desert Sage Seminars". That email contains your username.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1539">
                  <span className="font-semibold mr-2" data-id="element-1540">2.</span>
                  <span data-id="element-1541">
                    Your browser may be saving an incorrect password. Try
                    clearing the password box and re-type the correct password.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1542">
                  <span className="font-semibold mr-2" data-id="element-1543">3.</span>
                  <span data-id="element-1544">
                    BEFORE resetting your password, add
                    Administration@DesertSageSeminars.com to your Safe Senders
                    list so that you can receive our emails.
                  </span>
                </li>
              </ul>
            </Card>

            {/* Reset Form */}
            <Card className="p-8" data-id="element-1545">
              <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1546">
                Reset Your Password
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1547">
                <div data-id="element-1548">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1549">
                    Email Address<span className="text-red-500" data-id="element-1550">*</span>
                  </label>
                  <div className="relative" data-id="element-1551">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1552">
                      <Mail className="h-5 w-5 text-gray-400" data-id="element-1553" />
                    </div>
                    <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500" placeholder="Enter your email address" required data-id="element-1554" />
                  </div>
                  <p className="mt-2 text-sm text-gray-500" data-id="element-1555">
                    Enter the email address associated with your account
                  </p>
                </div>

                <Button type="submit" className="w-full font-semibold" size="lg" isLoading={isLoading} data-id="element-1556">
                  Send Reset Link <ArrowRight className="ml-2 h-4 w-4" data-id="element-1557" />
                </Button>
              </form>

              <div className="mt-6 pt-6 border-t border-gray-200 text-center" data-id="element-1558">
                <p className="text-sm text-gray-600" data-id="element-1559">
                  Remember your password?{' '}
                  <a href="/login-register" className="font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1560">
                    Back to Login
                  </a>
                </p>
              </div>
            </Card>

            {/* Support Section */}
            <div className="mt-8 text-center" data-id="element-1561">
              <p className="text-sm text-gray-600 mb-2" data-id="element-1562">
                Still having trouble?
              </p>
              <a href="/Contact" className="text-sm font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1563">
                Contact our support team
              </a>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1564">
                or call us at{' '}
                <a href="tel:602-377-6207" className="font-semibold text-gray-700 hover:text-brand-purple-600" data-id="element-1565">
                  602-377-6207
                </a>
              </p>
            </div>
          </> /* Success Message */ : <Card className="p-8 text-center" data-id="element-1566">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4" data-id="element-1567">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-1568" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1569">
              Check Your Email
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-1570">
              We've sent a password reset link to:
            </p>
            <p className="text-lg font-semibold text-brand-purple-600 mb-6" data-id="element-1571">
              {email}
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left" data-id="element-1572">
              <h3 className="font-semibold text-blue-900 mb-2" data-id="element-1573">Next Steps:</h3>
              <ol className="space-y-2 text-sm text-blue-800" data-id="element-1574">
                <li className="flex items-start" data-id="element-1575">
                  <span className="font-semibold mr-2" data-id="element-1576">1.</span>
                  <span data-id="element-1577">
                    Check your email inbox for a message from Desert Sage
                    Seminars
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1578">
                  <span className="font-semibold mr-2" data-id="element-1579">2.</span>
                  <span data-id="element-1580">Click the password reset link in the email</span>
                </li>
                <li className="flex items-start" data-id="element-1581">
                  <span className="font-semibold mr-2" data-id="element-1582">3.</span>
                  <span data-id="element-1583">Create a new password for your account</span>
                </li>
              </ol>
            </div>
            <p className="text-sm text-gray-600 mb-6" data-id="element-1584">
              Didn't receive the email? Check your spam folder or{' '}
              <button onClick={() => setIsSubmitted(false)} className="font-medium text-brand-purple-600 hover:text-brand-purple-700 hover:underline" data-id="element-1585">
                try again
              </button>
            </p>
            <Button onClick={() => window.location.href = '/login-register'} variant="outline" size="lg" data-id="element-1586">
              Back to Login
            </Button>
          </Card>}
      </div>
    </div>;
}